import { CommonAPI } from "../Client";
import { appendProcessedFile } from "../../../utils/imageUploadProcessor";

const buildQueryParams = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : "";
};

export const getEmailTemplateAPI = (payload) => {
  return CommonAPI.get(`/emailtemplate${buildQueryParams({
    page: payload?.page ?? 0,
    size: payload?.size ?? 5,
  })}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addEmailTemplateAPI = (payload) => {
  return CommonAPI.post("/emailtemplate", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateEmailTemplateAPI = (payload) => {
  return CommonAPI.put("/emailtemplate", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteEmailTemplateAPI = (id) => {
  return CommonAPI.delete(`/emailtemplate/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getSMSTemplateAPI = () => {
  return CommonAPI.get("/sms-template")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addSMSTemplateAPI = (payload) => {
  return CommonAPI.post("/sms-template", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateSMSTemplateAPI = (payload) => {
  return CommonAPI.put("/sms-template", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteSMSTemplateAPI = (id) => {
  return CommonAPI.delete(`/smstemplate/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addSendeMailAPI = (payload) => {
  return CommonAPI.post("/sendemail", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addSendSMSAPI = (payload) => {
  return CommonAPI.post("/send-sms", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addSendWhatsappAPI = (payload) => {
  return CommonAPI.post("/sendwhatsapp", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const receiveEmailAPI = (payload) => {
  return CommonAPI.post("/receiveemail", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getUsersAPI = (payload) => {
  return CommonAPI.get(`/users${buildQueryParams({
    hasCourse: payload?.hasCourse,
  })}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllUsersAPI = (payload) => {
  return CommonAPI.get(`/alluser?page=${payload?.page || 0}&size=${payload?.size || 10}&role=${payload?.role || ''}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getBlogAPI = (params) => {
  return CommonAPI.get(`/blog?page=${params?.page || 0}&size=${params?.size || 10}&search=${params?.search || ''}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getSingleBlogAPI = (id) => {
  return CommonAPI.get(`/blog/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addBlogAPI = (payload) => {
  return CommonAPI.post("/blog", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateBlogAPI = (payload) => {
  return CommonAPI.put("/blog", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteBlogAPI = (id) => {
  return CommonAPI.delete(`/blog/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addBlogImgAPI = async (payload) => {
  const formData = new FormData();
  await appendProcessedFile(formData, "file", payload.file);

  return CommonAPI.post("/blog/addthumbnail", formData, {
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryTtTi35D4MiWOz5uq",
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllTemplatePlaceholdersApi = async () => {
  try {
    const response = await CommonAPI.get(`/api/offer-letter/placeholders`);
    return response;
  }
  catch (error) {
    throw error;
  }
};
